import React from 'react';
import '../App.css';
import { Link } from 'react-router-dom';

const Catalogo = () => {
  return (
    <section className="catalogo-page">
      <h2>Catálogo de Productos</h2>
      {/* Placeholder para filtros */}
      <div className="catalogo-filtros-placeholder">
        <input type="text" placeholder="Buscar productos..." className="catalogo-busqueda" />
        <select className="catalogo-categoria">
          <option value="">Todas las categorías</option>
          <option value="cat1">Categoría 1</option>
          <option value="cat2">Categoría 2</option>
        </select>
      </div>
      {/* AVISO: Los enlaces a detalle de producto son solo para pruebas. Cuando sea funcional, se generarán dinámicamente. */}
      <div className="products-grid">
        <Link to="/producto/1" className="product-card-placeholder">Producto A</Link>
        <Link to="/producto/2" className="product-card-placeholder">Producto B</Link>
        <Link to="/producto/3" className="product-card-placeholder">Producto C</Link>
        <Link to="/producto/4" className="product-card-placeholder">Producto D</Link>
        <Link to="/producto/5" className="product-card-placeholder">Producto E</Link>
      </div>
      <div style={{marginTop: '1.5rem', color: '#b6b6b6', fontSize: '0.98rem', textAlign: 'center'}}>
        <em>Enlaces a detalle de producto solo para prueba. Cuando sea funcional, se generarán correctamente.</em>
      </div>
    </section>
  );
};

export default Catalogo; 